import React, {useState} from 'react';
import { connect } from 'react-redux';
import {withRouter, Link} from 'react-router-dom'
import { userActions } from '../../redux/actions/userActions';
import { userService } from '../../services/user.service';
import axios from 'axios';
import {trackPromise} from 'react-promise-tracker';
import {url} from '../../constants/urls';
import ErrorBox from '../UI/ErrorBox/ErrorBox';
import '../../assets/css/userView.css';
import withNavigation from '../../hoc/withNavigation/withNavigation';



const LoginView = (props) => {
    
    const [loggingIn, setLoggingIn] = useState(false);
    const [errorMessages, setErrorMessages] = useState(null);
    const [loginCredentials, setLoginCredentials] = useState({
            username: '',
            password: '',
            isRootUser: true,
            accountDomainName: '',
            submitted: false
        });
    
    const handleChange = (e) => {
       
        const { name, value, checked, type } = e.target;
       
        if(type.toLowerCase() === 'checkbox' || type.toLowerCase() === 'radio')
        {
            setLoginCredentials({ ...loginCredentials, [name]: checked });
        }
        else
        {            
            setLoginCredentials({ ...loginCredentials, [name]: value });
        }
               
        setErrorMessages(null);
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoggingIn(true);
        setLoginCredentials({ ...loginCredentials, submitted: true });
        const { username, password , isRootUser, accountDomainName} = loginCredentials;

        //if(!username || ! password) return;

        const { dispatch } = props;
        /*if (username && password) {
            dispatch(userActions.login(username, password));
        }*/
        const requestOptions = {
            url:`${url.baseURL}/user/login`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin' : '*' },
            data: { username, password, isRootUser, accountDomainName },
        };

        dispatch(userActions.setLoginRequest(username));

        trackPromise(axios(requestOptions)
        .then(userService.handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
            dispatch(userActions.setLoggedInUser(user));
            props.history.push("/");
            return user;
        }).catch(ex=>{
                       

            if(ex.response)
            {
                //setErrorMessage(ex.response.data.toString());

                if(typeof ex.response.data === 'object' && ex.response.data !== null && ex.response.data.errors)
                {
                    console.error("hhh",Object.keys(ex.response.data.errors))
                    let msgs = [];
                    Object.keys(ex.response.data.errors).map(er => msgs = msgs.concat(ex.response.data.errors[er]))
                    setErrorMessages(msgs);
                    console.log(msgs);
                }
                else
                {
                   
                    setErrorMessages([ex.response.data])
                }
                
            }
            else if (ex.request)
            {
                setErrorMessages(["Check your connection..."]);
            }
            else
            {
                setErrorMessages(["Login failed. Try again."]);
            }

            setLoggingIn(false);
            
            }));
    }
    return (
            <div className={"inline-modal-container"}>
            <div className="inline-modal">
                {/*<div className="alert alert-info">
                    Username: test<br />
                    Password: test
                </div>*/}
                <div className="inline-modal-header">Login</div>
                <form name="form" onSubmit={handleSubmit} >
                    
                    <ErrorBox errorMessages={errorMessages}/>
                    <div style={{display:'flex', alignItems:'center'}}>                        
                        <input type="checkbox"  name="isRootUser" checked={loginCredentials.isRootUser} onChange={handleChange} />
                        <label htmlFor="isRootUser">Account Admin/Root User</label>
                    </div>
                    {!loginCredentials.isRootUser && <div className={'form-group' + (loginCredentials.submitted && !loginCredentials.accountDomainName ? ' has-error' : '')}>
                        <label htmlFor="accountDomainName">Account Domain</label>
                        <input type="text" className="text-input" name="accountDomainName" value={loginCredentials.accountDomainName} onChange={handleChange} />
                        {loginCredentials.submitted && !loginCredentials.accountDomainName &&
                            <div className="help-block">Account Domain Name is required</div>
                        }
                    </div>}
                    <div className={'form-group' + (loginCredentials.submitted && !loginCredentials.username ? ' has-error' : '')}>
                        <label htmlFor="username">Username</label>
                        <input type="text" className="text-input" name="username" value={loginCredentials.username} onChange={handleChange} />
                        {loginCredentials.submitted && !loginCredentials.username &&
                            <div className="help-block">Username is required</div>
                        }
                    </div>
                    <div className={'form-group' + (loginCredentials.submitted && !loginCredentials.password ? ' has-error' : '')}>
                        <label htmlFor="password">Password</label>
                        <input type="password" className="text-input" name="password" value={loginCredentials.password} onChange={handleChange} />
                        {loginCredentials.submitted && !loginCredentials.password &&
                            <div className="help-block">Password is required</div>
                        }
                    </div>
                    <div style={{display:'flex',flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>                        
                        <div>
                            <Link className="button button-2" to={"/register"}>Create Account</Link>
                        </div>
                        <div><button disabled={loggingIn} type="submit" className="button button-1">Login</button>
                        {/*loggingIn &&
                            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        */}
                        </div>
                    </div>
                </form>
            </div>
            </div>
        );
}

function mapStateToProps(state) {
    const { loggingIn } = state.user;
    return {
        loggingIn
    };
}

export default withNavigation(withRouter(connect(mapStateToProps)(LoginView)));